import React from "react";

import Header
    from "../../components/Header";

import LeftMenu
    from "../../components/LeftMenu";

import DashboardSelector
    from "../../components/DashboardSelector";

import AmChartSunburst
    from "../../components/AmChartSunburst";

import BlockStackBarList
    from "../../components/BlockStackBarList";

import AmChartTreemap
    from "../../components/AmChartTreemap";

import MetricKpiBox
    from "../../components/MetricKpiBox";

import {
    DRAWER_GRADIENT
}
from "../../constants/colors";

import {
    useHistory
}
from "react-router-dom";

import useSpaceOrgDashboard
    from "./hooks/useSpaceOrgDashboard";

import MobileSpaceOrgDashboard
    from "./mobile/MobileSpaceOrgDashboard";


export default function SpaceOrgDashboard()
{

    //--------------------------------------------------------
    // Data
    //--------------------------------------------------------

    const {

        kpis,

        spaceBreakdown,

        topBuildings,

        buildingBreakdown,

        selectedBuilding

    } = useSpaceOrgDashboard();


    //--------------------------------------------------------
    // KPI values
    //--------------------------------------------------------

    let area =
        0;

    let capacity =
        0;

    let spaces =
        0;

    let buildings =
        0;


    for(let i = 0; i < kpis.length; i++)
    {

        const kpi =
            kpis[i];

        switch(kpi.code)
        {

            case "AREA":

                area =
                    kpi.value;

                break;

            case "CAPACITY":

                capacity =
                    kpi.value;

                break;

            case "SPACES":

                spaces =
                    kpi.value;

                break;

            case "BUILDINGS":

                buildings =
                    kpi.value;

                break;

            default:

                break;

        }

    }


    //--------------------------------------------------------
    // Derived state
    //--------------------------------------------------------

    const hasSpaceBreakdown =

        spaceBreakdown
        &&
        spaceBreakdown.length > 0;


    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const history =
        useHistory();


    const handleBuildingClick =
        function(obj)
        {

            history.push(
                "/spaceorgbuilding/" + obj
            );

        };


    //========================================================
    // Styles
    //========================================================

    const thisContainer =
    {

        display:
            "flex",

        position:
            "fixed",

        flexDirection:
            "column",

        width:
            "100%",

        minHeight:
            "100vh",

        left:
            "0px",

        top:
            "0px"

    };


    const mainContainer =
    {

        display:
            "flex",

        position:
            "fixed",

        top:
            "60px",

        left:
            "60px",

        bottom:
            "0px",

        right:
            "0px",

        overflow:
            "hidden"

    };


    const contentArea =
    {

        position:
            "absolute",

        top:
            0,

        left:
            0,

        right:
            0,

        bottom:
            0

    };


    //--------------------------------------------------------
    // KPI row
    //--------------------------------------------------------

    const kpiContainer =
    {

        position:
            "absolute",

        top:
            "20px",

        left:
            "20px",

        right:
            "450px",

        height:
            "90px",

        display:
            "flex",

        gap:
            "15px"

    };


    //--------------------------------------------------------
    // Main chart
    //--------------------------------------------------------

    const chartContainer =
    {

        position:
            "absolute",

        top:
            "130px",

        left:
            "20px",

        right:
            "430px",

        bottom:
            "30px"

    };


    //--------------------------------------------------------
    // Right instrumentation drawer
    //--------------------------------------------------------

    const drawer =
    {

        position:
            "fixed",

        top:
            "0px",

        right:
            "0px",

        bottom:
            "0px",

        width:
            "390px",

        borderRadius:
            "0px",

        background:
            DRAWER_GRADIENT,

        borderLeft:
            "1px solid rgba(255,255,255,0.06)",

        boxShadow:
            "-8px 0 28px rgba(0,0,0,0.45)",

        padding:
            "20px",

        paddingTop:
            "80px",

        overflow:
            "hidden"

    };


    const drawerTitle =
    {

        color:
            "rgba(255,255,255,0.88)",

        fontSize:
            "16px",

        fontWeight:
            500,

        marginBottom:
            "20px"

    };


    //--------------------------------------------------------
    // Entrance overlay
    //--------------------------------------------------------

    const overlayStyle =
    {

        position:
            "fixed",

        top:
            0,

        left:
            0,

        width:
            "100%",

        height:
            "100%",

        background:
            "rgba(255,255,255,0.85)",

        pointerEvents:
            "none",

        opacity:
            0,

        animation:
            "fadeOverlay 4s ease forwards"

    };


    //--------------------------------------------------------
    // Mobile
    //--------------------------------------------------------

    const isMobile =
        window.innerWidth <= 768;


    if(isMobile)
    {

        return (

            <MobileSpaceOrgDashboard />

        );

    }


    //========================================================
    // Render
    //========================================================

    return (

        <div style={thisContainer}>

            <Header
                transitionHide={true}
            />

            <LeftMenu />

            <div
                style={overlayStyle}
            />

            <DashboardSelector

                title="Space Dashboard"

                childDashboards={[]}

            />


            <div style={mainContainer}>

                <div style={contentArea}>


                    {/* ======================================
                        KPI ROW
                    ====================================== */}

                    <div style={kpiContainer}>

                        <MetricKpiBox

                            value={
                                Number(area)
                                    .toLocaleString()
                            }

                            label="Total Area (sqm)"

                        />

                        <MetricKpiBox

                            value={
                                Number(capacity)
                                    .toLocaleString()
                            }

                            label="Capacity"

                        />

                        <MetricKpiBox

                            value={
                                Number(spaces)
                                    .toLocaleString()
                            }

                            label="Spaces"

                        />

                        <MetricKpiBox

                            value={
                                Number(buildings)
                                    .toLocaleString()
                            }

                            label="Buildings"

                        />

                    </div>


                    {/* ======================================
                        SUNBURST
                    ====================================== */}

                    <div style={chartContainer}>

                        {

                            hasSpaceBreakdown
                            &&
                            (

                                <AmChartSunburst

                                    key="sunburst-loaded"

                                    width="100%"

                                    height="100%"

                                    chartData={
                                        spaceBreakdown
                                    }

                                    chartId="spaceorgdashboardsunburst"

                                    valueColumn="capacity"

                                    nameColumn="description"

                                    childrenColumn="children"

                                />

                            )

                        }

                    </div>


                    {/* ======================================
                        RIGHT DRAWER
                    ====================================== */}

                    <div style={drawer}>


                        {/* TOP 10 BUILDINGS */}

                        <div
                            style={{
                                height:
                                    "320px"
                            }}
                        >

                            <div style={drawerTitle}>

                                Top 10 Buildings

                            </div>

                            <div
                                style={{

                                    paddingLeft:
                                        "20px",

                                    paddingRight:
                                        "20px",

                                    paddingTop:
                                        "10px"

                                }}
                            >

                                <BlockStackBarList

                                    title="Top Buildings"

                                    rows={
                                        topBuildings
                                    }

                                    onSelect={
                                        handleBuildingClick
                                    }

                                />

                            </div>

                        </div>


                        {/* SPACE TYPE BREAKDOWN */}

                        <div
                            style={{

                                position:
                                    "absolute",

                                left:
                                    "40px",

                                right:
                                    "40px",

                                bottom:
                                    "40px",

                                height:
                                    "320px"

                            }}
                        >

                            <div
                                style={{

                                    color:
                                        "rgba(255,255,255,0.88)",

                                    fontSize:
                                        "16px",

                                    fontWeight:
                                        500,

                                    marginBottom:
                                        "10px"

                                }}
                            >

                                Space Type Breakdown

                            </div>


                            {

                                spaceBreakdown
                                &&
                                spaceBreakdown.length > 0
                                &&
                                (

                                    <AmChartTreemap

                                        chartId="spaceDashboardTreemap"

                                        width="100%"

                                        height="300px"

                                        chartData={
                                            spaceBreakdown
                                        }

                                        valueColumn="capacity"

                                        nameColumn="description"

                                        childrenColumn="children"

                                        onClick={
                                            function(item)
                                            {

                                                console.log(
                                                    item
                                                );

                                            }
                                        }

                                    />

                                )

                            }

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}